import { SignupForm } from '../components/SignupForm';
import { SignupPageTitle } from '../components/SignupPageTitle';

export const Signup = () => {
  return <div>
    <SignupPageTitle />
    <SignupForm />
  </div>
}